function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12.7999C14.2358 12.7999 12.8 14.2357 12.8 15.9999C12.8 17.7642 14.2358 19.1999 16 19.1999C17.7643 19.1999 19.2 17.7642 19.2 15.9999C19.2 14.2357 17.7643 12.7999 16 12.7999ZM16 18.1333C14.8224 18.1333 13.8667 17.1775 13.8667 15.9999C13.8667 14.8223 14.8224 13.8666 16 13.8666C17.1766 13.8666 18.1334 14.8223 18.1334 15.9999C18.1334 17.1775 17.1766 18.1333 16 18.1333Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1333 9.60001C19.3115 9.60001 20.2667 8.64488 20.2667 7.46668C20.2667 6.28847 19.3115 5.33334 18.1333 5.33334C16.9551 5.33334 16 6.28847 16 7.46668C16 8.64488 16.9551 9.60001 18.1333 9.60001Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9407 7.53906C14.9397 7.51452 14.9333 7.49106 14.9333 7.46653C14.9333 7.10706 15.0058 6.76787 15.1168 6.44467C11.3322 6.79134 8.18554 9.346 6.95888 12.802C7.33328 12.8063 7.68744 12.8809 8.02024 13.0025C9.11784 10.0916 11.7557 7.93586 14.9407 7.53906Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.28 7.99133C21.2181 8.36467 21.0869 8.71239 20.9077 9.03132C23.0965 10.5769 24.5322 13.122 24.5322 15.9999C24.5322 20.7049 20.704 24.5332 15.9989 24.5332C12.3488 24.5332 9.23624 22.226 8.02024 18.9972C7.68637 19.1188 7.33221 19.1935 6.95888 19.1977C8.28048 22.9204 11.8282 25.5999 16 25.5999C21.2938 25.5999 25.6 21.2937 25.6 15.9999C25.6 12.6559 23.8794 9.7108 21.28 7.99133Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.93335 18.1332C8.11156 18.1332 9.06669 17.1781 9.06669 15.9999C9.06669 14.8217 8.11156 13.8665 6.93335 13.8665C5.75514 13.8665 4.80002 14.8217 4.80002 15.9999C4.80002 17.1781 5.75514 18.1332 6.93335 18.1332Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32 16C32 7.16373 24.8363 0 16 0C7.16373 0 0 7.16373 0 16C0 24.8363 7.16373 32 16 32C17.2725 32 18.5067 31.8357 19.6928 31.5541C19.5029 31.2523 19.3611 30.9173 19.28 30.5579C18.2229 30.7968 17.1285 30.9333 16 30.9333C7.76533 30.9333 1.06667 24.2347 1.06667 16C1.06667 7.76533 7.76533 1.06667 16 1.06667C24.2347 1.06667 30.9333 7.76533 30.9333 16C30.9333 20.8811 28.5686 25.2107 24.9355 27.936C25.1552 28.2251 25.3227 28.5483 25.4357 28.9013C29.408 25.9893 32 21.3035 32 16Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 32.0002C23.5782 32.0002 24.5334 31.0451 24.5334 29.8669C24.5334 28.6886 23.5782 27.7335 22.4 27.7335C21.2218 27.7335 20.2667 28.6886 20.2667 29.8669C20.2667 31.0451 21.2218 32.0002 22.4 32.0002Z",
  fill: "currentColor"
});

function SvgSolarSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarSystem);
export default __webpack_public_path__ + "static/media/solar-system.279c2948.svg";
export { ForwardRef as ReactComponent };